module.exports = __webpack_public_path__ + "media/images/footer-3e45a27de0bb3b8af90f7808542fd948.png";